module.exports = __webpack_public_path__ + "f086d560b05faf9b8025db08ae4993ab.png";